const COS_HOST = "cos.xiaorukj.cloud";

export function buildCosThumbnail(source, width = 720) {
  if (!source || typeof source !== "string" || /^(data:|blob:)/i.test(source)) return source || "";
  try {
    const url = new URL(source, window.location.origin);
    if (url.hostname !== COS_HOST || url.searchParams.has("q-sign-algorithm") || url.search.includes("imageMogr2")) {
      return source;
    }
    const safeWidth = Math.max(240, Math.min(1600, Math.round(Number(width) || 720)));
    const separator = source.includes("?") ? "&" : "?";
    return `${source}${separator}imageMogr2/thumbnail/${safeWidth}x/format/webp/interlace/1`;
  } catch (error) {
    return source;
  }
}
